import { Box, Header, Text } from '@rbilabs/universal-components';

import Link from 'components/link';
import { getDesignToken, primitive } from 'styles/constants';
export const Section = Box.withConfig({
  background: primitive.$mayoEggWhite,

  width: {
    base: 'full',
    md: 'auto',
  },
  marginX: {
    base: '0',
    md: 'auto',
  },
  paddingX: {
    base: '0',
    md: '3rem',
  },
  maxWidth: {
    base: 'full',
    md: getDesignToken('layout-section-max-width'),
  },
});

export const HomepageAlertContainer = Box.withConfig({
  flexDirection: 'column',
  background: primitive.$bbqBrown,
  padding: '8',
  marginBottom: '8',

  borderRadius: {
    base: '0px',
    md: '10px',
  },
  marginTop: {
    base: '0',
    md: '8',
  },
});

export const AlertHeader = Header.withConfig({
  variant: 'headerTwo',
  marginTop: '0',
  fontFamily: 'heading',
  fontWeight: 'normal',
  color: primitive.$mayoEggWhite,
  textTransform: getDesignToken('text-transform-headlines'),
  marginBottom: '4',
});

export const AlertBody = Text.withConfig({
  variant: 'copyOne',
  margin: '0',
  color: primitive.$mayoEggWhite,
});

export const LinkItem = Link.withConfig({
  color: primitive.$mayoEggWhite,
  textDecoration: 'none',
  fontSize: 'md',
  _hover: {
    _web: {
      cursor: 'pointer',
    },
    color: primitive.$fieryRed,
    textDecoration: 'underline',
  },
});
